const AccountingSystemTypes = {
  YARDI: 'YARDI',
  AIM: 'AIM',
  FORTRESS: 'FORTRESS',
  RESMAN: 'RESMAN',
  REALPAGE: 'REALPAGE',
  _Values: () =>
    Object.keys(AccountingSystemTypes)
      .filter(key => typeof AccountingSystemTypes[key] !== 'function')
      .map(key => AccountingSystemTypes[key]),
};

const AccountingPostTypes = {
  BATCH_ON_POST: "BATCH_ON_POST",
  BATCH_ON_ACTIVITY: "BATCH_ON_ACTIVITY",
  POST_ON_ACTIVITY: "POST_ON_ACTIVITY",
  POST_ON_DEPOSIT: "POST_ON_DEPOSIT",
  _Values: () =>
    Object.keys(AccountingPostTypes)
      .filter(key => typeof AccountingPostTypes[key] !== 'function')
      .map(key => AccountingPostTypes[key]),
};


const PropertyOnboardingStatus = {
  ONBOARDED: 'ONBOARDED',
  OFFBOARDED_SUCCESS: 'OFFBOARDED_SUCCESS',
  OFFBOARDED_ERROR: 'OFFBOARDED_ERROR',
  UNINTEGRATED_SUCCESS: 'UNINTEGRATED_SUCCESS',
  UNINTEGRATED_ERROR: 'UNINTEGRATED_ERROR',
  _Values: () =>
    Object.keys(PropertyOnboardingStatus)
      .filter(key => typeof PropertyOnboardingStatus[key] !== 'function')
      .map(key => PropertyOnboardingStatus[key]),
};

const PropertyTypes = {
  SINGLE_FAMILY: 'SINGLE_FAMILY',
  MULTI_FAMILY: 'MULTI_FAMILY',
  MARKET_RATE: 'MARKET_RATE',
  AFFORDABLE: 'AFFORDABLE',
  SENIOR: 'SENIOR',
  STUDENT_HOUSING: 'STUDENT_HOUSING',
  COMMERCIAL: 'COMMERCIAL',
  MIXED: 'MIXED',
  _Values: () =>
    Object.keys(PropertyTypes)
      .filter(key => typeof PropertyTypes[key] !== 'function')
      .map(key => PropertyTypes[key]),
};

module.exports = { AccountingSystemTypes, PropertyOnboardingStatus, PropertyTypes, AccountingPostTypes };